
import { Component, Mixins, Watch } from 'vue-property-decorator';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { NotificationMixin } from '../mixins';

@Component
export default class PickupOrDropOff extends Mixins(NotificationMixin, ResponsivenessMixin) {
  private formData = {
    isCanadapostDropOff: {
      show: true,
      name: 'CPCPickup',
    },
    isSchedulePickupRemainder: {
      show: true,
      name: 'SchedulePickup',
    },
    isSchedulePickupResponsibilities: {
      show: true,
      name: 'PickupNotMonitored',
    },
    isNextDayPickup: {
      show: true,
      name: 'NextDayPickup',
    },
    isResidentialPickup: {
      show: true,
      name: 'ResidentialPickup',
    },
    isSchedulePickupCanpar: {
      show: true,
      name: 'ScheduleCanparPickup',
    },
    isGls: {
      show: true,
      name: 'GLSNoPickupFee',
    },
  }

  get isTablet(): boolean {
    return this.$vuetify.breakpoint.lgAndDown;
  }

  @Watch('isNotificationPrefs', { immediate: true })
  private populatePreferences(newValue: boolean) {
    if (newValue) {
      this.formData.isCanadapostDropOff.show = this.searchNotificationPref(
        this.formData.isCanadapostDropOff.name,
      );
      this.formData.isSchedulePickupRemainder.show = this.searchNotificationPref(
        this.formData.isSchedulePickupRemainder.name,
      );
      this.formData.isSchedulePickupResponsibilities.show = this.searchNotificationPref(
        this.formData.isSchedulePickupResponsibilities.name,
      );
      this.formData.isNextDayPickup.show = this.searchNotificationPref(
        this.formData.isNextDayPickup.name,
      );
      this.formData.isResidentialPickup.show = this.searchNotificationPref(
        this.formData.isResidentialPickup.name,
      );
      this.formData.isSchedulePickupCanpar.show = this.searchNotificationPref(
        this.formData.isSchedulePickupCanpar.name,
      );
      this.formData.isGls.show = this.searchNotificationPref(
        this.formData.isGls.name,
      );
    }
  }
}
